/// HOOKS ///
import { useNavigate } from "react-router-dom";
import useQuoteTotals from "hooks/quote/totals";
/// MUI ///
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
/// FM ///
import { motion } from "framer-motion";
/// TYPES ///
import { SelfOrder } from "api/types/order";
/// LUXON ///
import { DateTime } from "luxon";
/// STYLES ///
import { row_text_motion } from "styles/universal/row";
import { row_btn_style } from "styles/universal/row";
import { row_text_item_style } from "styles/universal/row";
/// URLS ///
import { shop_url } from "components/navigation/endpoints";
import { order_url } from "components/navigation/endpoints";

interface Props {
  self_order: SelfOrder
}

export default function CxSOItem({ self_order }: Props) {
  const navigate = useNavigate();
  const totals = useQuoteTotals(self_order);
  const theme = useTheme();
  const is_sm =  useMediaQuery(theme.breakpoints.up("sm"));

  const goTo = () => {
    navigate(`/${shop_url}/${order_url}/${self_order?.id ?? 0}`)
  }

  return (
    <Grid item xs={12}>
      <motion.button
        initial="rest"
        whileHover="hover"
        animate="rest"
        variants={row_text_motion}
        onClick={goTo}
        style={row_btn_style}>
        <Grid container>
          <Grid item xs={6} md={4}>
            <Typography variant="body2" align="left" noWrap sx={row_text_item_style}>
              {DateTime.fromISO(self_order?.created ?? "").toLocal().toFormat(is_sm ? "LLL dd yyyy" : "L/d/yy")}
            </Typography>
          </Grid>
          <Grid item xs={6} md={4}>
            <Typography variant="body2" noWrap sx={[row_text_item_style, {textAlign: {xs: "right", md: "left"}}]}>
              {self_order?.name ?? ""}
            </Typography>
          </Grid>
          <Grid item xs={0} md={4}>
            <Typography variant="body2" align="right" noWrap sx={row_text_item_style}>
            {
              is_sm ?
              `${(totals.subtotal + totals.tax1 + totals.tax2 + totals.discount).toFixed(2)}` :
              ""
            }
            </Typography>
          </Grid>
        </Grid>
      </motion.button>
    </Grid>
  )
}
